export default __webpack_public_path__ + "static/media/solucao-06.ee94517b.webp";